'use client';

import { useParams } from 'next/navigation';
import { CSSProperties, FC } from 'react';
import rewritesMap from 'root/.build/rewrites-map.json';
import { gtmPushDownload } from 'modules/gtm/modules/sections/page/page';
import { NextLink } from 'modules/i18n/navigation';
import { usePathname } from 'modules/next/hooks';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';

export type ILinkProps = Parameters<typeof NextLink>[0] & {
  style?: CSSProperties;
};

export const Link: FC<ILinkProps> = ({ href, children, ...props }) => {
  const pathname = usePathname();
  const { locale } = useParams();
  const { togglePageLoading } = useSiteConfig();

  if (typeof href === 'object') {
    href.pathname = href.pathname
      ? (rewritesMap as any)[href.pathname] || href.pathname
      : href.pathname;
  } else if (typeof href === 'string') {
    let rewrittenHref = (rewritesMap as any)[href] || href;

    if (!rewrittenHref.includes('http') && !rewrittenHref.includes('mailto')) {
      rewrittenHref = rewrittenHref
        .replace(locale as string, '')
        .replace(/\/{1,}/g, '/');

      if (!rewrittenHref.startsWith('/')) {
        rewrittenHref = `/${rewrittenHref}`;
      }
    }

    href = rewrittenHref;
  } else {
    href = (rewritesMap as any)[href] || href;
  }

  const handleDownloadLink = (href?: string | null) => {
    if (href && (href.includes('download') || href.includes('pdf'))) {
      gtmPushDownload({
        fileName: href.split('/').pop() || '',
        linkUrl: href,
      });
    }
  };

  return (
    <NextLink
      href={href}
      prefetch={false}
      {...props}
      onClick={(e) => {
        const _href = typeof href === 'object' ? href.pathname : href;
        handleDownloadLink(_href);

        _href !== pathname && togglePageLoading?.(true);

        props?.onClick?.(e);
      }}
    >
      {children}
    </NextLink>
  );
};
